import {
    Dialog,
    DialogTitle,
    DialogContent,
    Autocomplete,
    DialogActions,
    Button,
    TextField
} from '@mui/material';
import { useEffect, useState } from 'react';
import paymentportalservice from '../../services/paymentportalservice';

function AssignVendorModal({ open, onClose, handleAssignVendor }) {
    const [vendors, setVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState("");

    useEffect(() => {
        fetchVendors();
    }, []);

    const fetchVendors = async () => {
        const response = await paymentportalservice.FetchVendors();
        setVendors(response);
    }

    const sortedVendors = [...vendors].sort(
        (a, b) => a.category.name.localeCompare(b.category.name)
    )

    const handleSelectVendor = (event, value) => {
        if (!value) {
            return;
        }

        setSelectedVendor(value);
    }

    return (
        <Dialog
            open={open}
            maxWidth="sm"
            sx={{
                height: '100%'
            }}
            fullWidth
        >
            <DialogTitle
                sx={{
                    fontSize: 16,
                    fontWeight: 600,
                    borderBottom: 1,
                    borderBottomColor: '#F0F0F0'
                }}
            >
                Assign Vendor
            </DialogTitle>

            <DialogContent
                sx={{ minHeight: 450, mt: 2 }}
            >
                {
                    vendors ?
                        <Autocomplete
                            disablePortal
                            options={sortedVendors}
                            fullWidth
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label={"Choose Vendor"}
                                />
                            }
                            getOptionLabel={(option) => option.name}
                            groupBy={(option) => option.category.name}
                            onChange={handleSelectVendor}
                        />
                        :
                        null
                }
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                >
                    Close
                </Button>

                <Button
                    onClick={() => handleAssignVendor(selectedVendor)}
                    variant='contained'
                >
                    Assign Vendor
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AssignVendorModal;